import { render, staticRenderFns } from "./PerQuery.vue?vue&type=template&id=240d2460&scoped=true"
import script from "./PerQuery.vue?vue&type=script&lang=js"
export * from "./PerQuery.vue?vue&type=script&lang=js"
import style0 from "./PerQuery.vue?vue&type=style&index=0&id=240d2460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d2460",
  null
  
)

export default component.exports